import { useQuery } from "@tanstack/react-query";
import { VideoCard } from "./VideoCard";
import { fetchBskyFeed } from "@/services/bluesky";
import { Skeleton } from "./ui/skeleton";

export const VideoGrid = () => {
  const { data: videos, isLoading, error } = useQuery({
    queryKey: ['bsky-feed'],
    queryFn: fetchBskyFeed,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
  });

  console.log('VideoGrid state:', { videos, isLoading, error });

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="h-48 w-full rounded-lg" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-4 w-1/2" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error instanceof Error) {
    return (
      <div className="text-center py-10">
        <p className="text-red-500">
          Error loading videos: {error.message}
        </p>
      </div>
    );
  }

  if (!videos?.length) {
    return (
      <div className="text-center py-10">
        <p>No videos found</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {videos.map((video) => (
        <VideoCard key={video.id} {...video} />
      ))}
    </div>
  );
};